import TablaRegisteredCPAsRow from "./rows/TablaRegisteredCPAsRow";
import AdminCard from "../cards/AdminCard";
import { REGISTERED_CPAS_FIELDS } from "../../../utils/configs/adminCardConfigs";

function TablaRegisteredCPAs({ rows, onSendReminder }) {
  if (!rows || rows.length === 0) {
    return (
      <div className="note info">
        <b>No registered CPAs found</b>
      </div>
    );
  }

  return (
    <div className="table-wrapper">
      <table className="table admin-table">
        <thead>
          <tr>
            <th className="col-date">Date Joined</th>
            <th className="col-name">Firstname</th>
            <th className="col-name">Lastname</th>
            <th className="col-email">Email</th>
            <th className="col-status">Status</th>
            <th className="col-date">Last Reminder</th>
            <th className="col-actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((cpa, idx) => (
            <TablaRegisteredCPAsRow
              key={idx}
              cpa={cpa}
              onSendReminder={onSendReminder}
            />
          ))}
        </tbody>
      </table>

      {/* Mobile friendly cards */}
      <div className="admin-validate-cards">
        {rows.map((cpa, idx) => {
          const actions = [
            {
              key: "reminder",
              text: "Send Reminder",
              icon: "mail",
              onClick: () => onSendReminder(cpa),
              className: "btnAccept",
            },
          ];

          return (
            <AdminCard
              key={idx}
              data={cpa}
              fields={REGISTERED_CPAS_FIELDS}
              actions={actions}
            />
          );
        })}
      </div>
    </div>
  );
}

export default TablaRegisteredCPAs;
